import { LoadingButton } from '@mui/lab';
import { Box, styled, Toolbar } from '@mui/material';

// Styled components
export const GlassBox = styled(Box)(({ theme }) => ({
  background: 'rgba(3, 3, 3, 0.65)',
  borderRadius: '16px',
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(19.9px)',
  WebkitBackdropFilter: 'blur(19.9px)',
  border: '1px solid rgba(3, 3, 3, 0.52)',
}));

export const GlassButton = styled(LoadingButton)(({ theme }) => ({
  background: 'rgba(255, 211, 105, 0.55)',
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(14.2px)',
  WebkitBackdropFilter: 'blur(14.2px)',
  border: '1px solid rgba(255, 211, 105, 1)',
}));

export const CustomToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  background: 'linear-gradient(135deg, #000 0%, #010002 100%)',
}));

export const SectionBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
}));
